import { Checkbox } from 'Components/Core';
import { ChangeEventWithData } from 'Components/Core/types';
import { actions } from 'Data/ReduxViewModels/WorksheetBatchUpdate';
import { useDispatch, useSelector } from 'react-redux';

const WorksheetBatchUpdateSelectWorksheetCheckbox = ({ worksheetId, disabled }: any) => {
  const dispatch = useDispatch();
  const selected = useSelector((state) => state.worksheetBatchUpdate.worksheetsState[worksheetId]?.selected);
  return (
    <Checkbox
      value={selected}
      disabled={disabled}
      onChange={(e: ChangeEventWithData<HTMLInputElement>) =>
        dispatch(actions.setSelected({ worksheetId, selected: e.data?.value }))
      }
    />
  );
};

export default WorksheetBatchUpdateSelectWorksheetCheckbox;
export { WorksheetBatchUpdateSelectWorksheetCheckbox };
